/* eslint-disable ember/classic-decorator-hooks, ember/no-computed-properties-in-native-classes */
import EmberObject, { computed } from '@ember/object';

import * as CommonUtils from '../../../utils/common';

export default class PowerDetailResults extends EmberObject {
  stage;
  powerSupply;
  resistorCurrent;
  stageLetter;
  order;

  init() {
    super.init();

    if (CommonUtils.isNullOrUndefined(this.stage)) {
      this.opAmp = null;
      this.inputSupplyCurrent = null;
    }

    if (!CommonUtils.isNullOrUndefined(this.stage)) {
      this.stageLetter = this.stage.stageLetter;
      this.order = this.stage.order;
    }
  }

  @computed('stage') get opAmp() {
    var stage = this.stage;
    var result = null;
    if (stage) {
      result = stage.circuit.opAmp.partNumber;
    }

    return result;
  }

  @computed('stage') get inputSupplyCurrent() {
    var stage = this.stage;
    var result = null;
    if (stage) {
      result = stage.circuit.opAmp.supplyCurrent;
    }

    return result;
  }

  get power() {
    return this.powerSupply * this.inputSupplyCurrent;
  }
}
